export const PREFERRED_LANGUAGES = ['es', 'en', 'pt', 'it', 'fr', 'ja', 'de'] as const

export type PreferredLanguage = typeof PREFERRED_LANGUAGES[number]

/** Languages currently supported by conversational call providers. */
export const CALL_LANGUAGES = ['es', 'en', 'pt', 'it', 'fr', 'ja', 'de'] as const

export type CallLanguage = typeof CALL_LANGUAGES[number]

export function isPreferredLanguage(value: unknown): value is PreferredLanguage {
  return typeof value === 'string' && PREFERRED_LANGUAGES.includes(value as PreferredLanguage)
}

export function parsePreferredLanguage(value: unknown): PreferredLanguage | undefined {
  return isPreferredLanguage(value) ? value : undefined
}

export function normalizePreferredLanguage(
  value: unknown,
  fallback: PreferredLanguage = 'es'
): PreferredLanguage {
  return parsePreferredLanguage(value) ?? fallback
}

export function isCallLanguage(value: unknown): value is CallLanguage {
  return typeof value === 'string' && CALL_LANGUAGES.includes(value as CallLanguage)
}

export function parseCallLanguage(value: unknown): CallLanguage | undefined {
  return isCallLanguage(value) ? value : undefined
}

export function normalizeCallLanguage(
  value: unknown,
  fallback: CallLanguage = 'es'
): CallLanguage {
  return parseCallLanguage(value) ?? fallback
}
